import {i18n} from '@online-offer/i18n';
import {Text} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

export function FinancialProductSignedSnapshotNotice(props: TestIdProps) {
  return (
    <Text size="small" color="secondary" data-testid={suffixTestId('signedSnapshot', props)}>
      {i18n.t('financialProducts.signedSnapshot')}
    </Text>
  );
}
